import styled from "@emotion/styled";
import React, { useEffect } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ConvertToRecipes from "../components/modals/ConvertToRecipes";
import RecipesLoading from "../components/recipes/RecipesLoading";
import { useSelector } from "react-redux";
import useUserRecipes from "../hooks/useUserRecipes";

export default function FilesToRecipes() {
  const convertedRecipes = useSelector(
    (state) => state.userRecipes.convertedRecipes
  );
  const fetchUserRecipes = useUserRecipes();

  async function fetchRecipesHandler(recipeTypes) {
    try {
      await fetchUserRecipes(recipeTypes);
    } catch (e) {
      console.log("error while fetching user recipes", e);
    }
  }
  useEffect(() => {
    fetchRecipesHandler(["converted"]);
  }, []);

  return (
    <>
      <Nav />
      <StyledFilesToRecipes>
        <h3 className="heading">Files To Recipes</h3>
        <div className="box">
          <h4>Bring Your Recipes to Life!</h4>
          <p className="description">
            Instantly transform cookbook pages or recipe images into
            interactive, guided cooking experiences.
          </p>
          <ConvertToRecipes hideCloseIcon={true} />
        </div>
        <RecipesLoading
          className="manual-recipes"
          data={convertedRecipes}
          title="Converted Recipes"
          notFoundMsg={"No custom recipes yet"}
        />
      </StyledFilesToRecipes>

      <Footer />
    </>
  );
}

const StyledFilesToRecipes = styled.section`
  width: var(--tablet-width);
  margin: var(--section-margin) auto;
  .heading {
    margin-bottom: var(--heading-margin-sm);
  }
  .box {
    margin: auto;
    text-align: center;
    h2 {
      font-size: 2.2rem;
      color: var(--primary-color);
    }
    h4 {
      color: var(--secondary-color);
    }
    .description {
      /* color: var(--secondary-dark-color); */
      max-width: 50ch;
      margin: auto;
      margin-bottom: 30px;
    }
  }
  @media (max-width: 600px) {
    h3 {
      text-align: center;
    }
  }
`;
